import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UserDeactivationFailedAction = {
	type: 'USER_DEACTIVATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UserDeactivationFailedAction => ({
	type: 'USER_DEACTIVATION_FAILED',
	payload,
});
